import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!url || !key) {
  console.error(
    'Missing Supabase environment variables. ' +
    'Copy web/.env.example → web/.env and fill in your project values.'
  )
}

// We use manual type assertions in each query rather than the generic
// Database type parameter, to avoid requiring Supabase CLI type-gen.
export const supabase = createClient(url, key)
